// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScreenMain_wrapper__1cypn"};